import React, { useContext, useEffect, useState } from 'react';
import { FormContext } from '../../FormContext';
import { getDateDepend, getMinMaxDate } from '../../utils/utilFunctions';
import InputAddRemove from './InputAddRemove';
import { isFieldSigned, determineIsDisabled } from './utils.js';
import moment from 'moment';

const Input = ({ field_multiple_primary, field_multiple_id, field_multiple, field_autocomplete, field_type, field_disabled_approver, field_column, field_id, field_label, field_placeholder, field_disabled, field_mandatory, field_value = "", field_date_depend, field_number_max, field_number_min, field_multiple_type, field_date_min, field_date_max, field_price }) => {
  const { handleChangeInput, formElements, formStatus, formPageType, formApprovalIndex, formUserLock, formMultipleType, formChatPerson, formOfficers } = useContext(FormContext);
  const [minDate, setMinDate] = useState(field_date_min || null);
  const [maxDate, setMaxDate] = useState(field_date_max || null);
  const [inputValue, setInputValue] = useState(field_value);

  // Prevent scroll from changing number input value
  const handleWheel = (e) => {
    // Only prevent scroll behavior if the element is focused
    if (document.activeElement === e.target) {
      e.preventDefault();
    }
  };

  useEffect(() => {
    const inputElement = document.getElementById(field_id);
    if (inputElement && field_type === 'number') {
      inputElement.addEventListener('wheel', handleWheel, { passive: false });
      
      return () => {
        inputElement.removeEventListener('wheel', handleWheel);
      };
    }
  }, [field_id, field_type]);

  // Your existing useEffect for summation
//   useEffect(() => {
//   if (field_id?.startsWith('summation_')) {
//     let sum = 0;
//     formElements.pages?.forEach(page => {
//       page.parts?.forEach(part => {
//         part.fields?.forEach(field => {
//           // Sum up field_price if exists
//           if (field.field_price !== undefined && !field.field_id?.startsWith('summation_')) {
//             const price = parseFloat(field.field_price) || 0;
//             sum += price;
//           }

//           // Sum up selected option_price from select/radio fields
//           if (field.field_options && field.field_value) {
//             const selectedOption = field.field_options.find(opt => 
//               opt.option_label === field.field_value
//             );
//             if (selectedOption?.option_price !== undefined) {
//               const optionPrice = parseFloat(selectedOption.option_price) || 0;
//               sum += optionPrice;
//             }
//           }

//         });
//       });
//     });
    
//     if (sum.toString() !== inputValue) {
//       setInputValue(sum.toString());
//       handleChangeInput(field_id, { target: { value: sum.toString() } });
//     }
//   }
// }, [formElements]);

// useEffect(() => {
//   if (field_id?.startsWith('summation_')) {
//     let sum = 0;
//     formElements.pages?.forEach(page => {
//       page.parts?.forEach(part => {
//         part.fields?.forEach(field => {
//           // Sum up field_price if exists
//           if (field.field_price !== undefined && !field.field_id?.startsWith('summation_')) {
//             const price = parseFloat(field.field_price) || 0;
//             sum += price;
//           }

//           // Sum up selected option_price from select/radio fields
//           if (field.field_options && field.field_value) {
//             const selectedOption = field.field_options.find(opt => 
//               opt.option_label === field.field_value
//             );
            
//             // Skip if option has deposit_slip in mandatory fields
//             const hasDepositSlip = selectedOption?.option_mandatory_yes?.includes('cheque_no') || 
//                                  selectedOption?.option_mandatory_yes?.includes('deposit_slip');
            
//             if (!hasDepositSlip && selectedOption?.option_price !== undefined) {
//               const optionPrice = parseFloat(selectedOption.option_price) || 0;
//               sum += optionPrice;
//             }
//           }
//         });
//       });
//     });
    
//     if (sum.toString() !== inputValue) {
//       setInputValue(sum.toString());
//       handleChangeInput(field_id, { target: { value: sum.toString() } });
//     }
//   }
// }, [formElements]);

useEffect(() => {
  if (field_id?.startsWith('summation_')) {
    let sum = 0;
    formElements.pages?.forEach(page => {
      page.parts?.forEach(part => {
        part.fields?.forEach(field => {
          // Skip if field has skip_summation: true
          if (!field.skip_summation) {
            // // Sum up field_price if exists
            // if (field.field_price !== undefined && !field.field_id?.startsWith('summation_')) {
            //   const price = parseFloat(field.field_price) || 0;
            //   sum += price;
            // }

            // Sum up field_price only if field has a value
            if (field.field_price !== undefined && 
                !field.field_id?.startsWith('summation_') && 
                field.field_value !== undefined && 
                field.field_value !== '') {
              const price = parseFloat(field.field_price) || 0;
              sum += price;
            }

            // Sum up selected option_price from select/radio fields
            if (field.field_options && field.field_value) {
              const selectedOption = field.field_options.find(opt => 
                opt.option_label === field.field_value
              );
              
              // Skip if option has skip_summation: true
              if (selectedOption?.option_price !== undefined && !selectedOption.skip_summation) {
                const optionPrice = parseFloat(selectedOption.option_price) || 0;
                sum += optionPrice;
              }
            }
          }
        });
      });
    });
    
    if (sum.toString() !== inputValue) {
      setInputValue(sum.toString());
      handleChangeInput(field_id, { target: { value: sum.toString() } });
    }
  }
}, [formElements]);

// Modified onChange handler for price fields
const handleInputChange = (event) => {
  let newValue = event.target.value;

  // Convert to lowercase if input looks like an email
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  console.log('emailRegex')
  if (emailRegex.test(newValue)) {
    console.log('it is a email')
    newValue = newValue.toLowerCase();
    // Update the event target value to ensure the lowercase value is used
    event.target.value = newValue;
  }else{
    console.log('it is not an email')
  }
  
  if (field_type === 'number') {
    // Enforce min/max for number fields
    if (field_number_min !== undefined && newValue !== "") {
      if (Number(newValue) < field_number_min) {
        newValue = field_number_min.toString();
      }
    }
    if (field_number_max !== undefined && newValue !== "") {
      if (Number(newValue) > field_number_max) {
        newValue = field_number_max.toString();
      }
    }
  }

  if (field_type === 'date') {
    const date = moment(newValue);
    if (!newValue || ((!minDate || date.isSameOrAfter(minDate)) && (!maxDate || date.isSameOrBefore(maxDate)))) {
      setInputValue(newValue);
      handleChangeInput(field_id, event);
    }
  } else if (field_type === 'number' && field_price !== undefined) {
    setInputValue(newValue);
    // Update both value and price
    handleChangeInput(field_id, {
      ...event,
      target: { 
        ...event.target, 
        value: newValue,
        price: newValue 
      }
    });

    // Calculate and update summation fields
    const summationFields = [];
    formElements.pages?.forEach(page => {
      page.parts?.forEach(part => {
        part.fields?.forEach(field => {
          if (field.field_id?.startsWith('summation_')) {
            summationFields.push(field.field_id);
          }
        });
      });
    });

    let sum = 0;
    formElements.pages?.forEach(page => {
      page.parts?.forEach(part => {
        part.fields?.forEach(field => {
          if (field.field_price !== undefined && !field.field_id?.startsWith('summation_')) {
            const price = field.field_id === field_id ? 
              parseFloat(newValue) || 0 : 
              parseFloat(field.field_price) || 0;
            sum += price;
          }
        });
      });
    });

    // Update all summation fields
    summationFields.forEach(summationId => {
      handleChangeInput(summationId, { target: { value: sum.toString() } });
    });
  } else {
    setInputValue(newValue);
    handleChangeInput(field_id, event);
  }
};

  useEffect(() => {
    if (typeof field_date_depend !== 'undefined') {
      const date_depend_arr = field_date_depend.split("/");
      try {
        const date_depend = getDateDepend(formElements, date_depend_arr[0]);
        const minmax_date = getMinMaxDate(date_depend, date_depend_arr[1], date_depend_arr[2], date_depend_arr[3]);
        setMinDate(minmax_date.min_date);
        setMaxDate(moment(minmax_date.max_date).format("YYYY-MM-DD"));
      } catch (error) {
        console.log(error)
      }
    } 
    if(field_date_min && field_date_max) {
      setMinDate(field_date_min);
      setMaxDate(field_date_max);
    }
  }, [formElements, field_date_depend, field_date_min, field_date_max]);

  useEffect(() => {
    if (!field_id?.startsWith('summation_')) {
      setInputValue(field_value);
    }
  }, [field_value, field_id]);

  let isSigned = isFieldSigned(field_id, formMultipleType, formChatPerson, formOfficers, field_multiple_type);

  const handleAutoComplete = (event, field_autocomplete) => {
    if (field_autocomplete && field_autocomplete === "User" && event.target.value.length > 2) {
      window[`autocomplete${field_autocomplete}`](event.target.value, field_id);
    }
  };

  const hideTimePicker = (event, field_id, field_type) => {
    if (field_type === 'date' || field_type === 'time') {
      window['hideTimePicker'](field_id);
    }
    handleChangeInput(field_id, event);
  };

  const handleFocus = (field_id, event, field_type) => {
    switch (field_type) {
      case 'date':
        window['triggerDatePicker'](field_id, minDate, maxDate);
        break;
      case 'time':
        window['triggerTimePicker'](field_id);
        break;
      default:
        break;
    }
    handleChangeInput(field_id, event);
  };

  const validateMinMax = (value) => {
    if (!value) return value;

    if (field_type === 'date') {
      const dateValue = moment(value);
      if (minDate && dateValue.isBefore(minDate)) {
        return moment(minDate).format('YYYY-MM-DD');
      }
      if (maxDate && dateValue.isAfter(maxDate)) {
        return moment(maxDate).format('YYYY-MM-DD');
      }
      return value;
    }
  
    if ((field_number_min || field_number_max) && value !== "") {
      const numValue = Number(value);
      if (numValue > field_number_max) {
        return field_number_max;
      } else if (numValue < field_number_min) {
        return field_number_min;
      }
      return value;
    }
    return value;
  };
  

  const isDisabled = determineIsDisabled(
    formUserLock,
    formPageType,
    field_multiple_id,
    isFieldSigned(field_id, formMultipleType, formChatPerson, formOfficers, field_multiple_type),
    field_id,
    formApprovalIndex,
    field_disabled_approver,
    field_disabled,
    formStatus
  ) || field_id?.startsWith('summation_');

  return (
    <div className={`form-group ${field_column ? field_column : 'col-sm-6'}`}>
      <label>
        <span dangerouslySetInnerHTML={{ __html: field_label }}></span>
        <font color="red">{field_mandatory === 'yes' ? '*' : ''}</font>
      </label>
      <input
        type={field_type === 'number' ? 'number' : 'text'}
        placeholder={field_placeholder ? field_placeholder : ' '}
        value={validateMinMax(inputValue)}
        disabled={isDisabled}
        onChange={handleInputChange}
        onFocus={event => handleFocus(field_id, event, field_type)}
        onKeyUp={(event) => handleAutoComplete(event, field_autocomplete)}
        min={minDate || field_number_min}
        max={maxDate || field_number_max}
        className="form-control form-input force-info"
        id={field_id}
        autoComplete="off"
        data-target-input="nearest"
        data-target={`#${field_id}`}
        data-toggle={field_type === 'time' && "datetimepicker"}
        onBlur={(event) => hideTimePicker(event, field_id, field_type)}
      />
      {!formUserLock && <InputAddRemove field_id={field_id} field_multiple_id={field_multiple_id} field_multiple_type={field_multiple_type} />}
    </div>
  );
};

export default Input;